<template>
  <div class="m-0 dbozone-font bg-petrenger" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-petrenger">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -petrenger`">{{ $t('3_5_bonus_20.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="col-2 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/scatter.png`)"
          alt="">
        </div>
        <div class="col-5 align-items-center p-0 d-flex ml-2">
          <span class="font-weight-bold text-sub" :class="`-${lang}`">{{$t('petrenger.scatter-desc')}}
            <!-- <br>{{$t('petrenger.scatter-desc')}} -->
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_9.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[9][4]}} <br>
            {{'4 - ' + paytable[9][3]}} <br>
            {{'3 - ' + paytable[9][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_8.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[8][4]}} <br>
            {{'4 - ' + paytable[8][3]}} <br>
            {{'3 - ' + paytable[8][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_7.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[7][4]}} <br>
            {{'4 - ' + paytable[7][3]}} <br>
            {{'3 - ' + paytable[7][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_6.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[6][4]}} <br>
            {{'4 - ' + paytable[6][3]}} <br>
            {{'3 - ' + paytable[6][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_5.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[5][4]}} <br>
            {{'4 - ' + paytable[5][3]}} <br>
            {{'3 - ' + paytable[5][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[4][4]}} <br>
            {{'4 - ' + paytable[4][3]}} <br>
            {{'3 - ' + paytable[4][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[3][4]}} <br>
            {{'4 - ' + paytable[3][3]}} <br>
            {{'3 - ' + paytable[3][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[2][4]}} <br>
            {{'4 - ' + paytable[2][3]}} <br>
            {{'3 - ' + paytable[2][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[1][4]}} <br>
            {{'4 - ' + paytable[1][3]}} <br>
            {{'3 - ' + paytable[1][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/symbol_0.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[0][4]}} <br>
            {{'4 - ' + paytable[0][3]}} <br>
            {{'3 - ' + paytable[0][2]}}
          </span>
        </div>
      </div>
      <!-- <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild1.png`)"
          alt="">
        </div>
        <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild2.png`)"
          alt="">
        </div>
         <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild3.png`)"
          alt="">
        </div>
         <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild4.png`)"
          alt="">
        </div>
         <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild5.png`)"
          alt="">
        </div>
      </div> -->
       <div class="d-flex flex-column nav-petrenger mt-3">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -petrenger`">{{ $t('petrenger.wild.title') }}</h5>
        </section>
      </div>
       <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild1.png`)"
          alt="">
        </div>
        <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild2.png`)"
          alt="">
        </div>
         <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild3.png`)"
          alt="">
        </div>
         <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild4.png`)"
          alt="">
        </div>
         <div class="col-2 p-0 mg-in-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/wild5.png`)"
          alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.wild.desc1') }}</li></span>
      </div>
       <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-8 p-0">
         <img class="mt-3 mb-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/multiplier.png`)"
          alt="">
        </div>
      </div>
      
       <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.wild.desc2') }}</li></span>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-6 p-0">
         <img class="mt-3 mb-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/allwild.png`)"
          alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.wild.desc3') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-petrenger mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -petrenger`">{{ $t('petrenger.freespin.title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-3 p-0 mg-left-right">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/scatter.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 mg-left-right">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/scatter.png`)"
          alt="">
        </div>
         <div class="col-3 p-0 mg-left-right">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/petrenger/scatter.png`)"
          alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.freespin.desc6') }}</li></span>
      </div>
       <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-8 p-0">
         <img class="mt-3 mb-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/scatter.png`)"
          alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.freespin.desc7') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.freespin.desc8') }}</li></span>
      </div>
       <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.freespin.desc9') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-petrenger mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -petrenger`">{{ $t('petrenger.featurebuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/petrenger/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.featurebuy.text1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('petrenger.featurebuy.text2') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-petrenger mt-4 mb-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -petrenger`">{{ $t('petrenger.way.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('petrenger.way.desc1') }}</li></span>
      </div>
      <div class="justify-content-center d-flex flex-col">
          <img class="mt-3 mb-3 icon-paytable" :src="require(`../../assets/paytable/petrenger/line_paytable.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('petrenger.way.desc2') }}</li></span>
      </div>
      <!-- <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('petrenger.way.desc4') }}</li></span>
      </div> -->
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('petrenger.way.desc6') }}</li></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-petrenger',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}

.content {
  background: #000013;
  height: 100%;
  /* width: 100%; */
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.mg-in-row{
  margin:0 5px 0 5px;
}
.mg-left-right{
  margin:0 20px 0 20px;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>